import { useState, useCallback } from 'react';
import toast from '../utils/toast';
import { useNavigate } from 'react-router-dom';
import { saveToken, getToken } from '../utils/managerToken';

export default function Generic() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // 🔵 GET - Buscar dados
    const GenericGet = useCallback(async ({ rota, caminho = '', pesquisa = '' }) => {
        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}${caminho && `/${caminho}`}${pesquisa && `/${pesquisa}`}`,
                {
                    headers: {
                        'Content-Type': 'aplication/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    method: 'GET'
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                throw new Error(response);
            }

            return response;
        } catch (error) {
            toast.error(error?.message || `Erro na requisição de ${caminho}`);
            console.error(`Erro ao buscar ${caminho}: ${error.message}`);
            return;
        } finally {
            setLoading(false);
        }
    }, []);

    // 🟢 POST - Criar novo registro
    const GenericPost = async ({ rota, caminho, body }) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(body),
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na criação';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response, status: res.status };
        } catch (error) {
            const msg = `Erro ao criar ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    // 🔥 DELETE - Excluir por ID
    const GenericDelete = async ({ rota, caminho, campos }) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}?${campos}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na requisição';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response.message, status: res.status };
        } catch (error) {
            const msg = `Erro ao excluir ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    // 🟠 PUT - Atualizar dados
    const GenericPut = async ({ rota, caminho, body }) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(body),
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na atualização';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response, status: res.status };
        } catch (error) {
            const msg = `Erro ao atualizar ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    // 🟠 PATCH - Atualizar dados
    const GenericPatch = async ({ rota, caminho, body }) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(body),
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na atualização';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response, status: res.status };
        } catch (error) {
            const msg = `Erro ao atualizar ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    return {
        GenericGet,
        GenericPost,
        GenericDelete,
        GenericPut,
        GenericPatch,
        loading,
    };
}
